import gql from 'graphql-tag';

export const IVR_CALL_CONTEXT_BY_SID = gql`
  query IvrCallContextBySid($params: GetIvrCallInput!) {
    ivrCallContextBySid(params: $params) {
      _id
      callSid
      patientId
      treatmentId
      surveyResultId
      orgName
      recordingSid
      recordingUrl
      recordingDuration
      status
      createdAt
      updatedAt
    }
  }
`;

export const IVR_CALL_DETAIL_BY_SID = gql`
  query IvrCallDetailBySid($params: GetIvrCallInput!) {
    ivrCallDetailBySid(params: $params) {
      context {
        _id
        callSid
        patientId
        treatmentId
        surveyResultId
        orgName
        recordingSid
        recordingUrl
        recordingDuration
        status
        createdAt
        updatedAt
        maxRetries
        retriesRemaining
        retryIntervalMinutes
        nextRetryAt
        attempts {
          status
          callSid
          at
        }
      }
      surveyResult {
        _id
        callSid
        updatedAt
        updatedBy {
          firstName
          lastName
          middleName
        }
      }
    }
  }
`;

export const IVR_CALL_STATUS_BY_SURVEY_RESULT = gql`
  query IvrCallStatusBySurveyResult($params: GetIvrCallBySurveyResultInput!) {
    ivrCallStatusBySurveyResult(params: $params) {
      phase
      description
      surveyResultId
      callSid
      callStatus
      completedStatus
      answeredCount
      attemptCount
      retriesRemaining
      nextRetryAt
      lastActivityAt
      recordingUrl
      patientOptedOut
    }
  }
`;

export const IVR_CALLS_FOR_PATIENT = gql`
  query IvrCallsForPatient($params: GetIvrCallsForPatientInput!) {
    ivrCallsForPatient(params: $params) {
      phase
      description
      surveyResultId
      callSid
      callStatus
      completedStatus
      answeredCount
      attemptCount
      retriesRemaining
      nextRetryAt
      lastActivityAt
      recordingUrl
      patientOptedOut
    }
  }
`;
